<ng-template>
  <gh-session-selector
    [formControl]="formControl"
    [uiId]="controlId"
    [treeOptions]="{ sourceSessionId: parentItemSessionId, type: parentItemSessionId ? 'parent-to-child' : 'available-sessions' }"
    [a11yLabelledby]="labelId"
    [a11yRequired]="required"
    [focusMe]="autofocus"
    [borderless]="borderless"
    [a11yDescription]="ariaDescription"
    [uiDisabled]="disabled"
    [readonly]="readonly"
    [attr.data-test-id]="e2eTestId"></gh-session-selector>
</ng-template>
